export const FETCH_INTERACTION_REQUEST = 'FETCH_INTERACTION_REQUEST'
export const FETCH_INTERACTION_SUCCESS = 'FETCH_INTERACTION_SUCCESS'
export const FETCH_INTERACTION_FAILURE = 'FETCH_INTERACTION_FAILURE'

export const FETCH_SUB_INSTANCES_REQUEST = 'FETCH_SUB_INSTANCES_REQUEST'
export const FETCH_SUB_INSTANCES_SUCCESS = 'FETCH_SUB_INSTANCES_SUCCESS'
export const FETCH_SUB_INSTANCES_FAILURE = 'FETCH_SUB_INSTANCES_FAILURE'

export const START_SUB_INSTANCE_REQUEST = 'START_SUB_INSTANCE_REQUEST'
export const START_SUB_INSTANCE_SUCCESS = 'START_SUB_INSTANCE_SUCCESS'
export const START_SUB_INSTANCE_FAILURE = 'START_SUB_INSTANCE_FAILURE'

export const FETCH_ITEMS_REQUEST = 'FETCH_ITEMS_REQUEST'
export const FETCH_ITEMS_SUCCESS = 'FETCH_ITEMS_SUCCESS'
export const FETCH_ITEMS_FAILURE = 'FETCH_ITEMS_FAILURE'

export const UPDATE_ITEMS = 'UPDATE_ITEMS'

export const FETCH_ITEM_METADATA_REQUEST = 'FETCH_ITEM_METADATA_REQUEST'
export const FETCH_ITEM_METADATA_SUCCESS = 'FETCH_ITEM_METADATA_SUCCESS'
export const FETCH_ITEM_METADATA_FAILURE = 'FETCH_ITEM_METADATA_FAILURE'

export const FETCH_OUTCOME_TASK_REQUEST = 'FETCH_OUTCOME_TASK_REQUEST'
export const FETCH_OUTCOME_TASK_SUCCESS = 'FETCH_OUTCOME_TASK_SUCCESS'
export const FETCH_OUTCOME_TASK_FAILURE = 'FETCH_OUTCOME_TASK_FAILURE'

export const ANSWER_OUTCOME_TASK_REQUEST = 'ANSWER_OUTCOME_TASK_REQUEST'
export const ANSWER_OUTCOME_TASK_SUCCESS = 'ANSWER_OUTCOME_TASK_SUCCESS'
export const ANSWER_OUTCOME_TASK_FAILURE= 'ANSWER_OUTCOME_TASK_FAILURE'

export const SET_CURRENT_ITEM_NUMBER = 'SET_CURRENT_ITEM_NUMBER'

export const ANSWER_ITEM_REQUEST = 'ANSWER_ITEM_REQUEST'
export const ANSWER_ITEM_SUCCESS = 'ANSWER_ITEM_SUCCESS'
export const ANSWER_ITEM_FAILURE = 'ANSWER_ITEM_FAILURE'

export const SET_COLOR_VARIANT = 'SET_COLOR_VARIANT'
export const SET_INTERACTION_TOKEN = 'SET_INTERACTION_TOKEN'
export const SET_INTERACTION_INSTANCE_ID = 'SET_INTERACTION_INSTANCE_ID'